import React, { useState, useEffect } from 'react';

const ClipGallery = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const token = localStorage.getItem('auth_token');
        const res = await fetch('/api/clips/history', {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        const data = await res.json();
        if (data.history) setHistory(data.history);
      } catch(e) { console.error('Clip history error:', e); }
      setLoading(false);
    };
    fetchHistory();
  }, []);

  const timeLeft = (expiresAt) => {
    const diff = new Date(expiresAt).getTime() - Date.now();
    if (diff <= 0) return null;
    const hrs = Math.floor(diff / (1000*60*60));
    const mins = Math.floor((diff % (1000*60*60)) / (1000*60));
    return hrs + 'h ' + mins + 'm';
  };

  const downloadClip = (fileUrl, name) => {
    const a = document.createElement('a');
    a.href = fileUrl;
    a.download = name || 'clip.mp4';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  if (loading) return <div style={{padding:'16px',textAlign:'center',color:'#64748b'}}>Loading history...</div>;

  return (
    <div>
      {history.length === 0 ? (
        <div style={{textAlign:'center',padding:'30px',color:'#475569',fontSize:'14px'}}>
          <div style={{fontSize:'32px',marginBottom:'8px'}}>🎬</div>
          No clips generated yet. Create your first viral clip!
        </div>
      ) : (
        <div style={{display:'flex',flexDirection:'column',gap:'10px',maxHeight:'400px',overflowY:'auto'}}>
          {history.map((entry, i) => {
            const expired = new Date(entry.expiresAt).getTime() < Date.now();
            const remaining = timeLeft(entry.expiresAt);
            const hasFiles = entry.files && entry.files.length > 0;
            return (
              <div key={entry.id || i} style={{padding:'12px 14px',background: expired ? 'rgba(255,255,255,0.02)' : 'rgba(255,255,255,0.04)',borderRadius:'10px',border:'1px solid ' + (expired ? 'rgba(255,255,255,0.04)' : 'rgba(255,255,255,0.08)'),opacity: expired ? 0.6 : 1}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:'8px',flexWrap:'wrap'}}>
                  <div style={{minWidth:0,flex:1}}>
                    <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'4px'}}>
                      <span style={{fontSize:'14px'}}>{expired ? '⏰' : '🎬'}</span>
                      <span style={{color:'#fff',fontSize:'13px',fontWeight:'700',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{entry.videoTitle || 'Video'}</span>
                    </div>
                    <div style={{color:'#fff',fontSize:'11px',fontWeight:'700'}}>
                      {entry.clipCount} clips • {new Date(entry.createdAt).toLocaleDateString('en-GB', {day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'})}
                    </div>
                  </div>
                  <div style={{flexShrink:0,textAlign:'right'}}>
                    {expired ? (
                      <span style={{padding:'3px 10px',borderRadius:'12px',fontSize:'11px',fontWeight:'600',background:'rgba(100,116,139,0.15)',color:'#64748b'}}>Expired</span>
                    ) : (
                      <span style={{padding:'3px 10px',borderRadius:'12px',fontSize:'11px',fontWeight:'600',background:'rgba(16,185,129,0.15)',color:'#10b981'}}>⏳ {remaining}</span>
                    )}
                  </div>
                </div>
                {/* Download buttons */}
                {!expired && hasFiles && (
                  <div style={{display:'flex',gap:'6px',marginTop:'8px',flexWrap:'wrap'}}>
                    {entry.files.map((file, j) => (
                      <button key={j} onClick={() => downloadClip(file, 'clip_' + (j+1) + '.mp4')} style={{padding:'5px 12px',borderRadius:'8px',border:'none',background:'linear-gradient(135deg,#8b5cf6,#06b6d4)',color:'#fff',fontSize:'11px',fontWeight:'700',cursor:'pointer',display:'flex',alignItems:'center',gap:'4px'}}>
                        ⬇ Clip {j+1}
                      </button>
                    ))}
                  </div>
                )}
                {!expired && !hasFiles && (
                  <div style={{marginTop:'6px',color:'#475569',fontSize:'10px',fontStyle:'italic'}}>Files available on clip generator page</div>
                )}
                {expired && (
                  <div style={{marginTop:'6px',color:'#475569',fontSize:'10px',fontStyle:'italic'}}>Clips expired — regenerate to get new clips</div>
                )}
              </div>
            );
          })}
        </div>
      )}
      <div style={{marginTop:'10px',padding:'8px',textAlign:'center',color:'#475569',fontSize:'11px',fontStyle:'italic'}}>
        Clips are available for download for 24 hours after generation
      </div>
    </div>
  );
};

export default ClipGallery;
